"use client"

import {
  InfiniteTable,
  TableSkeleton,
} from "@/app/components/infinite-table/infinite-table"
import { HeaderRow } from "@/app/components/table"
import type { BidItem } from "@anaconda/core/bid/types"
import { Cell } from "./cells"
import { COLUMNS } from "./columns"
import { useTableItems } from "./use-table-items"

const COMPONENTS = {
  HeaderRow: TableHeaderRow,
  RowContent,
  RowSkeleton,
} as const

const getItemKey = (item: BidItem) => item.bid.id

export function UserBidsTable() {
  const { items, loadNext } = useTableItems()

  return (
    <InfiniteTable
      getItemKey={getItemKey}
      items={items}
      loadNext={loadNext}
      components={COMPONENTS}
      initialItemCount={15}
    />
  )
}

export function UserBidsTableSkeleton() {
  return <TableSkeleton HeaderRow={TableHeaderRow} RowSkeleton={RowSkeleton} />
}

function TableHeaderRow() {
  return (
    <HeaderRow>
      {COLUMNS.map((column, index) => (
        <column.Header key={index} />
      ))}
    </HeaderRow>
  )
}

function RowContent({ content }: { content: BidItem }) {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <Cell key={index}>
          <column.Content {...content} />
        </Cell>
      ))}
    </>
  )
}

function RowSkeleton() {
  return (
    <>
      {COLUMNS.map((column, index) => (
        <Cell key={index}>
          <column.Skeleton />
        </Cell>
      ))}
    </>
  )
}
